const messages = {
  "ui.common.teamItem.noTeam": "No Team",
  "ui.common.teamItem.owners": "Owners",
} as const;

export default messages;
